import EmptyListPage from 'components/EmptyListPage/styled';

export default EmptyListPage;
